import Box from "../Box";
import Typography from "../Typography";

const SelectEmptyPlaceholder = () => {
  return (
    <Box padding="small">
      <Typography tag="p" variant="p-body3">
        No options available.
      </Typography>
    </Box>
  );
};

SelectEmptyPlaceholder.displayName = "DS.Select.EmptyPlaceholder";

export default SelectEmptyPlaceholder;
